import { Box, Button, Checkbox, Dialog, DialogContent, DialogTitle, FormControlLabel, FormGroup } from '@mui/material';
import React, { useState } from 'react';
import { useExtractionDetail } from '../../hooks/useExtraction';

const items = [
  { id: 1, label: 'Concrete Cube Test Result' },
  { id: 2, label: 'Concrete Work Type' },
  { id: 3, label: 'Concrete Type' }
];

const cleanCheckboxSx = {
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'transparent',
  },

  // unchecked box
  '& .MuiSvgIcon-root': {
    fontSize: 22,            // slightly bigger
    borderRadius: '4px',     // rounded like docs
  },

  // checked state
  '&.Mui-checked .MuiSvgIcon-root': {
    color: '#2c3e50',        // or theme primary
  },
};

function SgbuildexFromDetailDialog({ open, onClose, onConfirm, table }) {
  const {
    data: dataExtractionDetail = [],
    isFetching,
    isError
  } = useExtractionDetail({ table });
  const [selectedItems, setSelectedItems] = useState([]);
  const handleCheckboxChange = (item) => (event) => {
    if (event.target.checked) {
      setSelectedItems((prev) => [...prev, item]);
    } else {
      setSelectedItems((prev) =>
        prev.filter((selected) => selected.id !== item.id)
      );
    }
  }
  console.log(dataExtractionDetail)
  const handleSelecFormDetail = () => {
    console.log(selectedItems)
    onConfirm(selectedItems);
  };

  const isChecked = (id) =>
  selectedItems.some((selected) => selected.id === id);
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Available Form</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 3 }}>
          <FormGroup>
            {dataExtractionDetail?.data?.map((item) => (
              <FormControlLabel control={<Checkbox 
                sx={cleanCheckboxSx} 
                checked={isChecked(item.id)}
                onChange={handleCheckboxChange(item)}
                />} label={item.name} />
            ))}
          </FormGroup>
          <Button onClick={handleSelecFormDetail} sx={{ mt: 3, fontWeight: 'bold' }} fullWidth variant="contained" form="subscription-form">
            SUBMIT
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default SgbuildexFromDetailDialog;
